import { useState, useEffect, useContext } from "react";
import { AppContext } from "components/Context/AppContext";

const API_URL = process.env.REACT_APP_API_URL;

export default function AccountSelectModal({ onDone }) {
  const { setSelectedAccount } = useContext(AppContext);
  const [accounts, setAccounts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    fetch(`${API_URL}/accounts?token=${token}`)
      .then((r) => r.json())
      .then((data) => {
        if (!Array.isArray(data) || data.length === 0) {
          setError("No accounts are assigned to your user. Please contact support.");
          setLoading(false);
          return;
        }
        if (data.length === 1) {
          // Auto-select, no modal needed
          setSelectedAccount(data[0]);
          onDone();
          return;
        }
        setAccounts(data);
        setSelected(data[0]);
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to load accounts. Please try again.");
        setLoading(false);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleConfirm = () => {
    if (selected) {
      setSelectedAccount(selected);
      onDone();
    }
  };

  if (loading && !error) return null;

  return (
    <div style={{
      position: "fixed", inset: 0,
      background: "rgba(0,0,0,0.7)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 1000,
    }}>
      <div style={{
        background: "var(--gray_900_01)",
        border: "1px solid var(--gray_900)",
        borderRadius: 12,
        padding: "36px 40px",
        width: 400,
        maxWidth: "90vw",
        maxHeight: "85vh",
        display: "flex",
        flexDirection: "column",
      }}>
        <div style={{ fontSize: 20, fontWeight: 600, color: "var(--white_a700)", marginBottom: 8, flexShrink: 0 }}>
          Select Account
        </div>

        {error ? (
          <>
            <div style={{ fontSize: 13, color: "var(--red_500)", marginBottom: 24 }}>{error}</div>
            <button
              onClick={onDone}
              style={{
                width: "100%", padding: "10px 0", borderRadius: 6, border: "none",
                background: "var(--gray_900)", color: "var(--gray_400)",
                fontSize: 13, cursor: "pointer",
              }}
            >
              Close
            </button>
          </>
        ) : (
          <>
            <div style={{ fontSize: 13, color: "var(--gray_500)", marginBottom: 24, flexShrink: 0 }}>
              Choose the account you want to view.
            </div>

            <div style={{
              display: "flex", flexDirection: "column", gap: 8, marginBottom: 28,
              overflowY: "auto", minHeight: 0, flex: "1 1 auto",
            }}>
              {accounts.map((acc) => {
                const isSelected = selected?.account_id === acc.account_id;
                return (
                  <div
                    key={acc.account_id}
                    onClick={() => setSelected(acc)}
                    style={{
                      padding: "14px 16px",
                      borderRadius: 8,
                      flexShrink: 0,
                      border: isSelected ? "1px solid var(--indigo_a700)" : "1px solid var(--gray_900)",
                      background: isSelected ? "rgba(43,54,217,0.1)" : "transparent",
                      cursor: "pointer",
                      transition: "all 0.15s",
                    }}
                  >
                    <div style={{ fontSize: 14, fontWeight: 600, color: "var(--white_a700)" }}>
                      {acc.account_name}
                    </div>
                    <div style={{ fontSize: 11, color: "var(--gray_500)", marginTop: 3 }}>
                      Account #{acc.account_id}
                    </div>
                  </div>
                );
              })}
            </div>

            <button
              onClick={handleConfirm}
              disabled={!selected}
              style={{
                width: "100%", padding: "11px 0", borderRadius: 6, border: "none",
                flex: "0 0 auto",
                background: selected ? "var(--indigo_a700)" : "var(--gray_900)",
                color: selected ? "var(--white_a700)" : "var(--gray_500)",
                fontSize: 14, fontWeight: 600, cursor: selected ? "pointer" : "default",
                transition: "all 0.15s",
              }}
            >
              Continue
            </button>
          </>
        )}
      </div>
    </div>
  );
}
